import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core';

import Media from '../Media';
import ListItem from '../../ListItem';
import styles from 'components/DetailGeneralInfo/index.module.scss';
import FreeTextDisplay from './FreeTextDisplay';
import Completed from './Completed';
import Timestamp from './Timestamp';
import { TASK_EVIDENCE_TYPE } from '../../../utils/constants/task';
import { images } from '../../../utils/icons';
import { isEmpty } from 'lodash';

const useStyles = makeStyles(theme => ({
  listIcon: {
    background: theme.palette.secondary.light,
    borderRadius: '50%',
  },
}));

const getPropsByType = ({ item }) => {
  switch (item.type) {
    case TASK_EVIDENCE_TYPE.IMAGE.id:
    case TASK_EVIDENCE_TYPE.AUDIO.id:
      return {
        iconProps: { size: 'auto' },
        IconComponent: (
          <Media
            condense
            value={[
              {
                mediaType: item.type,
                url: item.contents,
              },
            ]}
          />
        ),
      };
    case TASK_EVIDENCE_TYPE.DESCRIPTION.id:
      return {
        IconComponent: (
          <img src={images.content} alt={TASK_EVIDENCE_TYPE.DESCRIPTION.name} />
        ),
        secondaryValue: (
          <FreeTextDisplay
            content={item.contents}
            completed={item.completed}
            timestamp={item.timestamp}
          />
        ),
      };
    case TASK_EVIDENCE_TYPE.QRCODE.id:
      return {
        IconComponent: (
          <img src={images.qrcode} alt={TASK_EVIDENCE_TYPE.QRCODE.name} />
        ),
        secondaryValue: (
          <FreeTextDisplay
            linkText="Link to QR code"
            content={item.contents}
            completed={item.completed}
            timestamp={item.timestamp}
          />
        ),
      };
    case TASK_EVIDENCE_TYPE.NUMERIC.id:
      return {
        IconComponent: (
          <img src={images.content} alt={TASK_EVIDENCE_TYPE.NUMERIC.name} />
        ),
        secondaryValue: (
          <FreeTextDisplay
            content={item.contents}
            completed={item.completed}
            timestamp={item.timestamp}
          />
        ),
      };
    default:
      return {
        IconComponent: (
          <img
            src={images.checkboxPlaceholder}
            alt={TASK_EVIDENCE_TYPE.CHECKBOX.name}
          />
        ),
      };
  }
};

const Evidence = ({ value: { data } } = {}) => {
  const classes = useStyles();

  return (
    <div>
      {isEmpty(data) && <span>-</span>}
      {Object.entries(data).map(([key, values], index) => {
        return (
          <div key={index}>
            <div className={styles.key}>
              {TASK_EVIDENCE_TYPE[key] ? TASK_EVIDENCE_TYPE[key].name : ''}
            </div>
            {values.map((item, index) => {
              const { IconComponent, ...props } = getPropsByType({ item });
              return (
                <ListItem
                  className={classes.listItem}
                  key={index}
                  alignItems="flex-start"
                  IconComponent={
                    <Completed completed={item.completed}>
                      {IconComponent}
                    </Completed>
                  }
                  value={item.description}
                  iconProps={{ size: 'small', className: classes.listIcon }}
                  {...(item.completed &&
                    item.timestamp && {
                      secondaryValue: <Timestamp value={item.timestamp} />,
                    })}
                  {...props}
                />
              );
            })}
          </div>
        );
      })}
    </div>
  );
};

Evidence.propTypes = {
  value: PropTypes.object,
};

export default Evidence;
